import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React from "react";
import styles from "./carousel-controls.module.css";
const CarouselControls = ({ children , customClassNames  })=>/*#__PURE__*/ _jsx("div", {
        className: cx(styles.wrapper, customClassNames),
        children: children
    });
export default CarouselControls;
